const DownloadIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.2458 2.75488C13.2458 2.34067 12.9101 2.00488 12.4958 2.00488C12.0816 2.00488 11.7458 2.34067 11.7458 2.75488L11.7459 13.8037L7.73154 9.92338C7.43372 9.6355 6.95891 9.64356 6.67103 9.94138C6.38315 10.2392 6.39121 10.714 6.68903 11.0019L11.1405 15.3048C11.8963 16.0354 13.0952 16.0354 13.8511 15.3048L18.3026 11.0019C18.6004 10.714 18.6084 10.2392 18.3206 9.94138C18.0327 9.64356 17.5579 9.6355 17.2601 9.92338L13.2459 13.8036L13.2458 2.75488ZM3.24609 14.3378C3.66031 14.3378 3.99609 14.6736 3.99609 15.0878V20.0542C3.99609 20.3027 4.19757 20.5042 4.44609 20.5042H20.5454C20.7939 20.5042 20.9954 20.3027 20.9954 20.0542V15.0878C20.9954 14.6736 21.3312 14.3378 21.7454 14.3378C22.1596 14.3378 22.4954 14.6736 22.4954 15.0878V20.0542C22.4954 21.1311 21.6224 22.0042 20.5454 22.0042H4.44609C3.36914 22.0042 2.49609 21.1311 2.49609 20.0542V15.0878C2.49609 14.6736 2.83188 14.3378 3.24609 14.3378Z'
        fill='black'
      />
    </svg>
  );
};

DownloadIcon.displayName = 'DownloadIcon';
export default DownloadIcon;
